<template>
    <div class="container">
        <div class="ceiling-view" v-if="ceilingType">
            <div class="ceiling-tab" :class="{'ceiling-fixed':ceilingType}">
                <van-tabs v-model="activeTab" :swipe-threshold="4" @click="tabChange">
                    <van-tab v-for="(item, index) in tabList" :key="index" :title="item.stage" >
                    </van-tab>
                </van-tabs>
                <div class="box"></div>
            </div>
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220620/1655706510544.png">
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220620/1655706568793.png">
            <div class="section2-btn" @click="JumpFn('数据分析是一种能力')"></div>
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220620/1655706588254.png">
        </div>
        <div class="section" id="section_0">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220620/1655706638993.png">
        </div>
        <div class="section-main">
            <div class="s-main">
                <van-tabs v-model="active">
                    <van-tab v-for="(item, index) in stageList" :key="index" :title="item.stage" class="tb">
                        <div class="t-title">
                            {{item.title}}
                        </div>
                        <img class="t-icon" src="https://s21.lgstatic.com/growth/activity/20210419/1618820076232.png">
                        <div class="target">
                            <div class="title">
                                <div class="target-link"></div>
                                <div class="text">学习目标</div>
                                <div v-if="item.details.length > 0" class="btn" @click="getTags(item)"></div>
                            </div>
                            <div class="content">
                                <div v-for="(val,ind) in item.phaseTargetList" :key="ind" class="content-list">
                                    <div class="icon"></div>
                                    <div class="text">{{val}}</div>
                                </div>
                            </div>
                            <div class="title title1">
                                <div class="target-link"></div>
                                <div class="text">实战项目</div>
                            </div>
                            <div class="content">
                                <div v-for="(val,ind) in item.skillsList" :key="ind" class="content-list">
                                    <div class="icon"></div>
                                    <div class="text">{{val}}</div>
                                </div>
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>

                <div class="tips-tab">
                    * 具体课程内容以实际课程安排和进度为准
                </div>
            </div>
            <button class="stage-more" @click="JumpFn('领取完整课程安排')">
                <img :src="imgObj.btn1">
            </button>
        </div>
        <div class="section" id="section_1">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20210907/1630995609312.png">
        </div>
        <div class="sw-section">
            <div class="swiper-container wrap-current">
                <div class="swiper-wrapper">
                    <div class="swiper-slide current-slider" v-for="(item, index) in swiperList" :key="index">
                        <img :src="item">
                    </div>
                </div>
                <div class="swiper-pagination current-pagination" />
            </div>
        </div>
        <div class="section">
            <img class="img" @click="JumpFn('获取更多项目资料')" src="https://s20.lgstatic.com/growth/activity/20220620/1655706941114.png">
        </div>
        <div class="section" id="section_2">
            <!-- <div class="section-pos" id="section_3"></div> -->
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20221118/1668750655669.jpg">
        </div>
        <!-- <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220624/1656040009966.png">
        </div> -->
        <!-- <div class="section padbtm60">
            <img class="img" @click="JumpFn" src="https://s21.lgstatic.com/growth/activity/20220620/1655707111179.png">
        </div> -->
        <div class="section section-fix">
            <img class="img img-fix" src="https://s20.lgstatic.com/growth/activity/20221118/1668750726733.jpg">
            <!-- <div class="sw-1section">
                <div class="swiper-container current-container" id="sw-section">
                    <div class="swiper-wrapper current-wraps">
                        <div
                            v-for="(value,inde) in swiperList1" :key="inde"
                            class="swiper-slide current-box"
                        >
                            <img class="company" :src="value"/>
                        </div>
                    </div>
                    <div class="swiper-pagination current-pagination" />
                </div>
            </div>
            <div class="sw2" id="sw2">
                <div class="swiper-container current-container2" id="sw-section2">
                        <div class="swiper-wrapper current-wraps">
                            <div
                                v-for="(value,inde) in swiperList2"
                                :key="inde"
                                class="swiper-slide current-box"
                            >
                                <img class="company" :src="value"/>
                            </div>
                        </div>
                        <div class="swiper-pagination current-pagination" />
                    </div>
            </div> -->
        </div>
        <button class="footer" @click="JumpFn('名额有限立即抢占')">
            <div class="box10-right img pay-btn-wrapper">
            <div class="pay-btn">
              好课速享 马上抢占
            </div>
          </div>
            <!-- <img class="icon-img" :src="imgObj.footer_icon"> -->
            <img class="H5activityIcon" v-if="activity.isShow" :src="activity.H5icon">
            <div class="img-box">
                <img
                    class="img-btns"
                    src="https://s21.lgstatic.com/growth/activity/20210831/1630410757988.png"
                >
            </div>
            <FooterPoup
                :id="27"
                :isDcsj="false"
            />
        </button>

        <div :class="{'modal-container': true, active: modalVisable}" v-if="modalVisable">
            <div :class="{'layer': true, active: modalVisable}"/>
            <div class="modal">
                <div :class="{'modal-content': true, active: modalVisable && modalType == 'text', 'active-img': modalVisable && modalType != 'text'}">
                    <div class="close-container">
                        <div
                            class="close"
                            @click="closeModal"
                        />
                    </div>
                    <div v-if="modalType == 'text'">
                        <div class="title">
                            {{ moadlData.title }}
                            <div class="sub-title">
                                {{ moadlData.stage }}
                            </div>
                        </div>
                        <div class="content">
                            <div v-for="(val,inde) in moadlData.details" :key="inde">
                                <div class="content-title">
                                    {{val.t}}
                                </div>
                                <div class="content-desi" v-for="(i,its) in val.desc" :key="its">
                                    {{i}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <RetainModal
            :visible="retainModalVisible"
            @removeHash="removeHash"
            pageId="1qjk"
        />
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import { handleJumpUrl } from '../../../uitl/getParam.js';
import List from './data.js'
import RetainModal from '../../../components/RetainModal/index.vue'
import { postIsBuyCourse } from '../../../service/api'
import { Tab, Tabs } from 'vant';
import activity from '../../../common/activity';
import FooterPoup from '../../../components/FooterPoup/index.vue'

Vue.use(Tab);
Vue.use(Tabs);

import { getEduAppVersion, isBiggerThanSpecifiedVersion } from '../../../uitl/getVersion'

// // ios
// window.appBeforeGoBack = function () {
//     window.location.hash = 'showModal'
//     return 0
// }
// // android
// if (isBiggerThanSpecifiedVersion(getEduAppVersion(), '2.3.4')) {
//     window.appBeforeUnLoaded = function () {
//         window.location.hash = 'showModal'
//         return true
//     }
// }
export default {
    name: 'JavaJaGouShiH5',
    components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        RetainModal,
        FooterPoup
    },
    data() {
        return {
            retainModalVisible: false,
            canShowModal: false,
            List,
            activity,//活动图标
            imgObj:{},
            imgList:[],
            imgList1:[],
            tabList:[],
            stageList:[],
            swiperList:[],
            rankList:[],
            swiperList1:[],
            ceilingType:false,//吸顶tab
            modalVisable:false,
            moadlData:{},
            current: '',
            modalType: 'text',
            activeTab:0,
            addressIdsMap: {
                "课程体系": "v1tve",
                "实战项目": "w1tvf",
                "就业服务": "x1tvg",
                "用户评价": "y1tvh",
                "领取完整课程安排": "z1tvi",
                "获取更多项目资料": "b1tvk",
                "名额有限立即抢占": "c1tvm",
                "数据分析是一种能力": "a1tvj"
            }
        };
    },
    mounted() {
        // this.watchHashChange()
        setTimeout(()=>{
            // this.eduPlatTrack('WebView', {'page_id': '1qjk',});
            this.platTrack('h5pv', {
                page_id: '1qjk',
            })
        },500)
        let dataList = this.List.data;
        this.imgObj = dataList.h5.imgObj
        this.imgList = dataList.h5.imgList
        this.imgList1 = dataList.h5.imgList1
        this.swiperList = dataList.h5.swiperList
        this.swiperList1 = dataList.h5.swiperList1
        this.swiperList2 = dataList.h5.swiperList2
        this.tabList = dataList.tabList1
        this.stageList = dataList.stageList
        this.rankList = dataList.rankList
        window.addEventListener('scroll', this.scrollTopFn)
        setTimeout(()=>{
            this.swiperInit()
            this.renderSwipers();
            this.rangeSwipers()
        },500)
    },
    destroyed () {
        window.removeEventListener('scroll', this.scrollTopFn)
    },
    methods: {
        scrollTopFn() {
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            this.ceilingType = scroll > 460 ? true : false; //吸顶tab
            let arr = [
                "section_0",
                "section_1",
                "section_2",
                // "section_3",
                // "section_4",
            ]
            arr.forEach((item,index) =>{
                if(document.getElementById(item).getBoundingClientRect().top < 100) {
                    this.activeTab = index
                }
            })
        },
        tabChange(val,title) {
            let arr = [
                "#section_0",
                "#section_1",
                "#section_2",
                // "#section_3",
                // "#section_4",
            ]
            this.$el.querySelector(arr[val]).scrollIntoView(true);
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            document.documentElement.scrollTop = scroll - 50
            document.body.scrollTop = scroll - 50
            // this.eduPlatTrack('WebButtonClick', {
            //     'page_id': '1qjk',
            //     'button_name': title
            // });
            this.platTrackClickFn(title)
        },
        JumpFn(str) {
            // this.eduPlatTrack('WebButtonClick', {
            //     'page_id': '1qjk',
            //     'button_name': '领取详细课程大纲'
            // });
            str && this.platTrackClickFn(str)
            setTimeout(() => {
              window.location.href = 'https://t.lagou.com/WR9BRRRrs05DD';
            }, 200);
        },
        watchHashChange() {
            const that = this
            window.addEventListener('hashchange', function(e) {
                postIsBuyCourse().then(res => {
                    if (res.state == 1) {
                        if (res.content) {
                            window.lgBridge && window.lgBridge.request('close', {}, (res) => {});
                        } else {
                            that.canShowModal = !res.content
                            if (window.location.hash == '#showModal' && that.canShowModal) {
                                that.retainModalVisible = true
                            }
                        }
                    }
                })
            })
        },
        removeHash() {
            this.retainModalVisible = false
            this.canShowModal = false
            window.location.hash = ''
        },
        closeModal(){
            this.looseBody();
            this.modalVisable = false;
        },
        fixedBody() {
            this.selfTop = document.body.scrollTop || document.documentElement.scrollTop;
            document.body.style.cssText += 'position:fixed;overflow: hidden;width:100%;height: auto;top: -' + this.selfTop + 'px';
        },
        looseBody() {
            var body = document.body;
            body.style.overflow = 'auto';
            body.style.height = 'auto';
            body.style.position = '';
            document.body.scrollTop = document.documentElement.scrollTop = parseInt(this.selfTop);
        },
        getTags(item){
            this.modalType = 'text';
            this.fixedBody();
            this.modalVisable = true;
            this.moadlData = item
        },
        swiperInit() {
            let option = {
                direction: 'horizontal',
                loop: true,
                speed: 1400,
                autoplayDisableOnInteraction: false,
                autoplay: 2000,
                spaceBetween: 30,
                pagination: '.current-pagination',
            };
            this.$nextTick(() => {
                const swiper = new Swiper('.wrap-current', option);
            });
        },
        renderSwipers() {
            let that = this;
            let option = {
                speed: 300,
                autoplay: 3000,
                loop: true,
                autoplayDisableOnInteraction: false,
                slidesPerView: 'auto',
                spaceBetween: 6,
                // onClick(e){
                //     that.getSlide(e.realIndex)
                // }
            };
            const swiper = new Swiper('.current-container', option);
            let option2 = {
                speed: 300,
                autoplay: 3000,
                loop: true,
                autoplayDisableOnInteraction: false,
                slidesPerView: 'auto',
                spaceBetween: 10
            };
            const swiper2 = new Swiper('.current-container2', option2);
        },
        rangeSwipers() {
            let option = {
                direction: 'vertical',
                loop: true,
                autoplay: 1,
                speed: 2000,
                freeMode:true,
                autoplayDisableOnInteraction: false,
                slidesPerView: 9
            };
            const swiperDom = new Swiper('.range_list', option);
            console.log(swiperDom)
        },
        platTrackClickFn(name) {
            this.platTrack('h5click', {
                page_id: '1qjk',
                address_id: this.addressIdsMap[name]
            })
        }
    }
};
</script>

<style lang='less' scoped>
.container {
    width: 100%;
    background: #EDEEFB;
    padding-bottom: 160px;
    .section {
        position: relative;
        width: 100%;
        &.padbtm60 {
            padding-bottom: 60px;
        }
        .img {
            width: 100%;
            display: block;
        }
        .img-icon {
            width: 158px;
            height: 158px;
            position: absolute;
            top: 0;
            right: 0;
        }
        .btn-img-1 {
            position: absolute;
            top: 0;
            left:0;
            width: 100%;
            height: 100%;
            background-color:transparent;
            border: none;
            z-index: 9;
        }
    }
    .ceiling-view {
        width: 100%;
        // height: 94px;
        // margin: 0px 0 40px;

        .ceiling-tab {
            position: relative;
            width: 100%;
            height: 94px;
            background: #FFFFFF;
            box-shadow: 0px 6px 8px 0px rgba(71, 68, 85, 0.08);
            z-index: 33;
            // /deep/ .van-tabs__wrap--scrollable{
            // height: 94px;
            // }
            .box {
                position: absolute;
                top: 0;
                right: 0;
                width: 60px;
                height: 94px;
                background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
            }
            /deep/ .van-tabs__nav {
                position: relative;
            }
            // /deep/ .van-tabs__wrap {
            //     height: 94px;
            // }
            /deep/ .van-tab {
                position: relative;
                min-width: 200px;
                height: 94px;
                color: #32355C;
                font-size: 30px;
                font-weight: 400;
            }
            /deep/.van-tab--active {
                box-sizing: border-box;
                color: #32355C;
                font-weight: 400;
                &::before{
                    content: '';
                    width: 32px;
                    height: 32px;
                    background: url('https://s21.lgstatic.com/growth/activity/20210830/1630305549390.png') no-repeat center;
                    background-size: 100% 100%;
                    position: absolute;
                    left: 16px;
                    top:50%;
                    transform: translateY(-50%);
                    transition-duration: 0.3s;
                }
                .van-tab__text {
                    padding-left: 24px;
                }
            }
            /deep/ .van-tabs__line {
                // bottom: 40px;
                background: linear-gradient(127deg, #DCAD7F 0%, #ECC39A 100%);
                width: 160px;
                height: 6px;

            }
        }
        .ceiling-fixed {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 30;
        }
    }

    .section-main {
        position: relative;
        width: 100%;
        margin-bottom: 100px;
        .stage-more {
            position: absolute;
            bottom: -54px;
            left: 50%;
            transform: translate(-50%);
            width: 488px;
            background-color:transparent;
            border: none;
            z-index: 9;
            img {
                width: 100%;
                display: block;
            }
        }
        .s-main {
            position: relative;
            margin: 0 auto;
            width: 688px;
            background-color: #fff;
            z-index: 2;
            border-radius: 8px;
            padding-bottom: 150px;
            box-shadow: 0px 2px 15px 0px rgba(225, 225, 225, 0.73);
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            overflow: hidden;
            .tb {
                position: relative;
                width: 100%;
                background-color: #fff;
                border-top-left-radius: 8px;
                border-top-right-radius: 8px;
                overflow: hidden;
                .t-title {
                    text-align: center;
                    font-size: 32px;
                    color: #555;
                    font-weight: 500;
                    padding: 25px 0 10px;
                }
                .t-icon {
                    width: 688px;
                    display: block;
                    height: 2px;
                }
                .target {
                    color: #3D3D3F;
                    font-size: 26px;
                    margin-top: 35px;
                    .title {
                        display: flex;
                        height: 49px;
                        align-items: center;
                        font-weight: bold;
                    }
                    .title1 {
                        margin-top: 38px;
                    }
                    .target-link {
                        width: 6px;
                        height: 22px;
                        background: linear-gradient(313deg, #7A7AA9 0%, #232545 100%);
                        margin-left: 46px;
                        margin-right: 8px;
                    }
                    .text {
                        flex: 1;
                    }
                    .btn {
                        width: 151px;
                        height: 49px;
                        background: url('https://s21.lgstatic.com/growth/activity/20210325/1616656811847.png') no-repeat;
                        background-size: 100% 100%;
                        margin-right: 40px;
                    }
                    .content {
                        margin-top: 10px;
                    }
                    .content-list {
                        display: flex;
                        color: #595959;
                        line-height: 48px;
                        font-size: 24px;
                        .icon {
                            width: 8px;
                            height: 8px;
                            background: #565659;
                            border-radius: 50%;
                            margin-left: 46px;
                            margin-top: 20px;
                            margin-right: 8px;
                        }
                        .text {
                            opacity: .7;
                            flex: 1;
                            width: 612px;
                            padding-right: 14px;
                        }
                    }
                }
            }
            .tips-tab {
                position: absolute;
                bottom: 80px;
                right: 40px;
                color: #666;
                font-size: 12px;
            }

        }
        /deep/ .van-tabs__wrap--scrollable{
            height: 106px;
        }
        /deep/ .van-tabs__nav {
            background: linear-gradient(313deg, #7A7AA9 0%, #232545 100%);
            height: 106px;
        }
        /deep/ .van-tabs--line .van-tabs__wrap {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
        }
        /deep/ .van-tab {
            width: 200px;
            height: 106px;
            color: #fff;
            font-size: 28px;
            font-weight: 400;
        }
        /deep/ .van-tabs__line {
            bottom: 40px;
            background: #fff;
            width: 64px;
            height: 6px;
        }
    }
    .sw-section {
        /deep/ .wrap-current {
            width: 9.2rem;
            height: 14.8rem;
            .swiper-wrapper {
                width: 9.173rem;
                img {
                    width: 100%;
                }
            }
            .swiper-pagination-bullet {
                border-radius: 50%;
                width: 0.2rem;
                height: 0.2rem;
                background: #1220FF;
                opacity: 0.5;
                // margin: 0 0.093rem;
                &-active {
                    width: 0.4rem;
                    height: 0.2rem;
                    background: #1220FF;
                    border-radius: 0.2rem;
                    opacity: 1;
                }
            }
        }
    }
    .sw-1section {
        width: 100%;
        height: 474px;
        background-color: rgba(22, 10, 83, .9);
        position: absolute;
        top: 384px;
        left: 0;
        .current-container {
            width: 100%;
            height: 466px;
            // position: absolute;
            // bottom: 210px;
            .current-wraps {
                width: 582px;
                position: absolute;
                padding-left: 10px;
                .current-box {
                    width:100% !important;
                    margin-left: 20px;
                    img {
                        width: 100%;
                    }
                }
            }
        }
    }
    .sw2 {
        position: absolute;
        top: 1018px;
        left: 28px;
        width: calc(100% - 28px);
        height: 674px;
        padding: 0 28px;
        box-sizing: border-box;
        img {
            width: 357px;
        }
        .current-container2 {
            width: 100%;
            height: 674px;
            position: absolute;
            bottom: 0;
            left: 0;
            .current-wraps {
                width: 357px;
                position: absolute;
                padding-left: 10px;
                .current-box {
                    width:357px !important;
                    // margin-left: 20px;
                    img {
                        width: 100%;
                    }
                }
            }
        }
    }
    .rank-main {
        width: 100%;
        background-color: rgba(22, 10, 83, .9);
        padding-bottom: 20px;
        .section-rank {
            width: 690px;
            margin: 0 auto;
            background-color: #fff;
            border-radius: 12px;
            .title {
                width: 690px;
                height: 112px;
                display: block;
                margin: 0 auto;
            }
        }
        .range_list {
            width: 606px;
            height: 719px;
            // position: absolute;
            // left: 50%;
            // transform: translate(-50%,0);
            // top: 280px;
        }
        /deep/ .range_list .swiper-wrapper {
            -webkit-transition-timing-function: linear;    /*之前是ease-out*/
            -moz-transition-timing-function: linear;
            -ms-transition-timing-function: linear;
            -o-transition-timing-function: linear;
            transition-timing-function: linear;
            margin: 0 auto;
        }
        .range_box {
            border-bottom: 1px dashed #ccc;
            display: flex;
            font-size: 24px;
            color: #666;
            height: 80px;
            line-height: 79px;
            box-sizing: border-box;
            box-sizing: border-box;
            .company {
                width: 118px;
                height: 38px;
                margin-left: 24px;
                text-align: center;
                margin-top: 19px;
            }
            .name {
                width: 90px;
                margin-left: 60px;
                text-align: center;
                opacity: .8;
            }
            .range {
                width: 100px;
                margin-left: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
                opacity: .8;
            }
            .course_name {
                height: auto;
                flex: 1;
                margin-left: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #FC2727;
                font-weight: bold;
            }
        }
    }




    .layer {
        position: fixed;
        z-index: 9;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.6);
        display: none;
        &.active {
            display: block;
        }
    }
    .modal {
        position: fixed;
        bottom: 180px;
        z-index: 10;
        display: flex;
        justify-content: center;
        .modal-content {
            width: 750px;
            height: 0;
            opacity: 0;
            transition: height .3s linear;
            overflow-y: scroll;
            &.active {
                opacity: 1;
                height: 962px;
                overflow: hidden;
            }
            &.active-img {
                opacity: 1;
                height: 662px;
                overflow: hidden;
            }
            background: #fff;
            border-radius: 18px 18px 0 0;
            position: relative;
            margin-right: 45px;
            box-sizing: border-box;
        }
        .close {
            width: 42px;
            height: 42px;
            background: url("https://s21.lgstatic.com/growth/activity/20210402/1617356751440.png") no-repeat;
            background-size: 42px 42px;
            position: absolute;
            right: 30px;
            top: 30px;
            border-radius: 50%;
            z-index: 1;
        }
        .title {
            margin-top: 82px;
            width: 658px;
            font-size: 32px;
            line-height: 40px;
            margin-bottom: 41px;
            padding-left: 45px;
            font-weight: bold;
            &-dot {
                width: 5px;
                height: 5px;
                border-radius: 5px;
                background: #FA4000;
            }
            .sub-title{
                color: #C69C6D;
                font-size: 26px;
                margin-top: 8px;
            }
        }
        .content {
            height: 755px;
            overflow-y: scroll;
        }
        .content-title {
            margin-bottom: 40px;
            font-weight: bold;
            color: #191F34;
            position: relative;
            padding-left: 47px;
            font-size: 26px;
            line-height: 28px;
            padding-right: 30px;
            &:before {
                content: '';
                width: 8px;
                height: 8px;
                background: #C69C6D;
                border-radius: 8px;
                position: absolute;
                left: 25px;
                top: 11px;
            }
        }
        .content-desi {
            margin-bottom: 48px;
            color: #5E6476;
            font-size: 26px;
            padding-left: 48px;
            padding-right: 30px;
        }
    }
    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: -1px;
        z-index: 999;
        width: 100%;
        box-shadow: 0px -12px 12px 0px rgba(156, 157, 185, 0.22);

        .pay-btn-wrapper {
          box-sizing: border-box;
          width: 750px;
          height: 158px;
          background-color: #fff;
          padding-top: 26px;
          .pay-btn {
            width: 90%;
            margin: 0 auto;
            height: 87px;
            line-height: 87px;
            color: #fff;
            border-radius: 30px;
            background-image: linear-gradient(90deg,  #fe5686, #ff8d5f);
          }
        }

        .img {
            width: 100%;
            display: block;
        }
        .icon-img {
            position: absolute;
            top: -40px;
            right: 30px;
            width: 311px;
        }
        .H5activityIcon {
            position: absolute;
            top: -50px;
            right: 42px;
            width: 209px;
        }
        .img-box {
            position: absolute;
            top: 20px;
            left: 0;
            width: 100%;
            height: 100px;
        }
        .img-btns {
            position: absolute;
            top: -10px;
            left: 0px;
            animation: left 2s infinite linear;
            width: 224px;
            height: 120px;
        }
        @keyframes left {
            0% {
                left: -50%;
            }
            50% {
                left: 100%;
            }
            100% {
                left: 200%;
            }
        }
    }
}
.section2-btn {
    position: absolute;
    left: 0;
    bottom: 40px;
    height: 110px;
    width: 100%;
}
.section-pos {
    position: absolute;
    top: 55%;
    height: 1px;
    width: 100%;
}
.section-fix {
    height: 750px;
    overflow: hidden;
    .img-fix {
    position: absolute;
    bottom: 0;
    left: 0;
}
}

</style>
